/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { numericRangeResponseDtoSchema } from "./numericRangeResponseDtoSchema";
import { propertyNeedsResponseDtoSchema } from "./propertyNeedsResponseDtoSchema";
import { z } from "zod/v4";

export const buyOrRentLeadInterestResponseDtoSchema = z.object({
    "type": z.enum(["BUY", "RENT"]),
"locations": z.optional(z.array(z.string())),
get "budget"(){
                return numericRangeResponseDtoSchema.optional()
              },
get "monthlyPaymentTarget"(){
                return numericRangeResponseDtoSchema.optional()
              },
get "propertyNeeds"(){
                return propertyNeedsResponseDtoSchema.optional()
              }
    })